@if(entry === 'participantEnrollment') {

<form nz-form [formGroup]="newContactForm" class="ppl-p0">
    @if(isAttrAvailable('newEmployer')){
    <ppl-accordion [title]="'Employer Details'" [isOpen]="true"
        *authorize="[pageId, tabId, 'EmployerDetails', 'section']">
        <ppl-association-details [sectionName]="'employer'" [gridData]="getProviderData('EMP')" [tabId]="tabId"
            [pageId]="pageId" [sectionId]="'EmployerDetails'" [gridCols]="getProviderColumns('EMP')" [readonly]="readonly"></ppl-association-details>
    </ppl-accordion>
    }

    @if(isAttrAvailable('newAuthRep')){

    <ppl-accordion [title]="'Designated Representative'" [isOpen]="true"
        *authorize="[pageId, tabId, 'DesignatedRepresentative', 'section']">
        <ppl-association-details [sectionName]="'authorized_representative'" [gridData]="getProviderData('AR')"
            [tabId]="tabId" [pageId]="pageId" [sectionId]="'DesignatedRepresentative'" [consumerData]="consumerData"
            [gridCols]="getProviderColumns('AR')" [readonly]="readonly" (actionSelected)="actionSelected($event)"></ppl-association-details>
    </ppl-accordion>

    }
    @if(isAttrAvailable('newProvider')){

    <ppl-accordion [title]="'Personal Assistant'" [isOpen]="true"
        *authorize="[pageId, tabId, 'PersonalAssistant', 'section']">
        <ppl-association-details [sectionName]="'independent_provider'" [gridData]="getProviderData('IR')"
            [tabId]="tabId" [pageId]="pageId" [sectionId]="'PersonalAssistant'" (actionSelected)="actionSelected($event)"
            [gridCols]="getProviderColumns('IR')" [readonly]="readonly"></ppl-association-details>

    </ppl-accordion>
    }

    @if(isAttrAvailable('newVendor')){
    <ppl-accordion [title]="'Vendor'" [isOpen]="true" *authorize="[pageId, tabId, 'Vendor', 'section']">
        <ppl-association-details [sectionName]="'vendor'" [gridData]="getProviderData('Vendor')" [tabId]="tabId"
            [pageId]="pageId" [sectionId]="'Vendor'" [gridCols]="getProviderColumns('vendor')" [readonly]="readonly"></ppl-association-details>
    </ppl-accordion>
    }

    @if(isAttrAvailable('newContractor')){
    <ppl-accordion [title]="'Independent Contractor'" [isOpen]="true"
        *authorize="[pageId, tabId, 'IndependentContractor', 'section']">
        <ppl-association-details [sectionName]="'independent_contractor'" [gridData]="getProviderData('IC')"
            [tabId]="tabId" [pageId]="pageId" [sectionId]="'IndependentContractor'"
            [gridCols]="getProviderColumns('IC')" [readonly]="readonly"></ppl-association-details>
    </ppl-accordion>
    }
    @if(isAttrAvailable('newLegalGuardian')){
    <ppl-accordion [title]="'Legal Guardian'" [isOpen]="true" *authorize="[pageId, tabId, 'LegalGuardian', 'section']">
        <ppl-association-details [sectionName]="'legal_guardian'" [gridData]="getProviderData('LG')" [tabId]="tabId"
            [pageId]="pageId" [sectionId]="'LegalGuardian'" [gridCols]="getProviderColumns('LG')" [readonly]="readonly"></ppl-association-details>
    </ppl-accordion>
    }
    @if(isAttrAvailable('newPOA')){
    <ppl-accordion [title]="'POA'" [isOpen]="true" *authorize="[pageId, tabId, 'POA', 'section']">
        <ppl-association-details [sectionName]="'poa'" [gridData]="getProviderData('POA')" [tabId]="tabId"
            [pageId]="pageId" [sectionId]="'POA'" [gridCols]="getProviderColumns('POA')" [readonly]="readonly"></ppl-association-details>
    </ppl-accordion>
    }

</form>
}
@else{
<ppl-accordion [title]="'Associations'" [isOpen]="true">

    @if(isMobileView){
    <div class="card-layout pl-0 pr-3">
        <div class="card" *ngFor="let association of prvdrAssociations">
            <div class="card-item mt-2">
                <strong>{{ association.participantFirstName }} {{ association.participantLastName }} ({{
                    association.participantPplId }})</strong>
            </div>
            <div class="card-item">
                {{association.providerTypeLabel}}
            </div>
            <div class="card-item">
                Start Date : {{association.associationStartDate}}
            </div>
            @if(association.associationEndDate) {
            <div>
                End Date : {{association.associationEndDate}}
            </div>
            }
            <div class="btn-group mt-3 mb-2 d-flex justify-content-between">
                @if(association.actions?.showStatus){
                <div class="mr-3">
                    <ppl-button ariaLabel="Manage Status" label="Manage Status" icon="fa fa-briefcase"
                        [customClass]="'ghost-button'" [iconPosition]="'left'"
                        (click)="action({data: association, action: 'showStatus'})"></ppl-button>
                </div>
                }

                @if(association.actions?.manageConsumer){
                <ppl-button ariaLabel="Manage Consumer" label="Manage Consumer" icon="fa fa-briefcase"
                    [customClass]="'ghost-button'" [iconPosition]="'left'"
                    (click)="action({data: association, action: 'manageConsumer'})"></ppl-button>
                }
            </div>
        </div>
    </div>
    } @else {
    <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="isAssociationsEditable"
        [data]="prvdrAssociations" [disableSelection]="true" [cols]="cols" [gridTitle]="false" [pagination]="false"
        [loadPage]="true" [actionButtons]="actions" (gridAction)="action($event)">
    </ppl-list-table>
    }
</ppl-accordion>
@if(isPA){
    <ppl-accordion [title]="'Auth Allocation by Consumer'" [isOpen]="true" *authorize="[pageId, tabId, 'AuthAllocationByConsumer', 'section']">
        <div class="table-style">
            <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true" [data]="weeklyLimitData"
                [disableSelection]="true" [cols]="weeklyLimitCols" (gridAction)="action($event)" [gridTitle]="false"
                [pagination]="false" [loadPage]="true" [actionButtons]="weeklyLimitButtons">
            </ppl-list-table>
        </div>
    </ppl-accordion>
}

<div class="filter-panel">
    <!-- <ppl-modal [showModal]="showModal" [title]="modalBody" [isOkText]="'Save'" (confirm)="handleCancel()"
        (cancel)="handleCancel()"> -->
        <ng-template #manageStatusDialog let-cancel="cancel">
        @if (mode === 'read' && !disableAddStatus) {
        <div pplFocusTrap class="custom-row">
            <div class="mr-2">
                <ppl-button #addStatusBtn label="Add Status" icon="fa fa-plus" [customClass]="'ghost-button dialog-btn'" [iconPosition]="'left'"
                    (click)="addStatus()"
                    *authorize="[pageId, tabId, 'AddCaseManager', 'section', 'edit']"></ppl-button>
            </div>
        </div>
        }

        @if (mode === 'read' && showMoveToInPPLReviewButton) {
        <div class="custom-row">
            <div class="mr-2">
                <ppl-button label="Move to PPL Review" icon="fa fa-arrow-circle-right" [customClass]="'ghost-button dialog-btn'"
                    [iconPosition]="'left'" (click)="moveToPPLReview()"
                    *authorize="[pageId, tabId, 'MoveToInPPLReview', 'section', 'edit']"></ppl-button>
            </div>
        </div>
        }

        @if(mode === 'edit' || mode === 'add') {
        <div pplFocusTrap>
        <div class="custom-row">
            <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'" [iconPosition]="'left'"
                (click)="cancelEdit()"></ppl-button>
            <ppl-button label="Save" icon="fa fa-floppy-o" [customClass]="'alt-button'" [iconPosition]="'left'"
                (click)="save()"></ppl-button>
        </div>

        <div class="ppl-mt20">
            <form nz-form nz-row [formGroup]="enrollmentStatus" class="ppl-p0">
                @if(isAttrAvailable('status')){
                <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
                    <nz-row>
                        <nz-form-label [nzSm]="5" [nzXs]="24" nzFor="status" class="ppl-form-label"
                            [authorizeField]="[pageId, tabId, 'Demographics', 'status']">{{
                            getAttributes("status").label }}
                            @if(getAttributes('status').mandatory === 'Y'){
                            <span [attr.aria-label]="'Required'">*</span>
                            }</nz-form-label>
                        <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control" nz-tooltip
                            nzTooltipTitle="{{getAttributes('status').tooltip}}" nzTooltipPlacement="topRight">
                            <div class="ppl-select" [ngClass]="{'error': validationErrors['status'] }">
                                <ppl-dropdown-select formControlName="status" id="status"
                                placeholder="Select Registration Status"
                                [disabled]="mode === 'edit' || disableStatus" [options]="allowedStatus"
                                [optionLabel]="'status'" [optionValue]="'status'">
                                </ppl-dropdown-select>
                            </div>
                            @if (validationErrors['status']) {
                            <span class="pl-1 error-message">{{validationErrors['status']}}</span>
                            }
                        </nz-form-control>
                    </nz-row>
                </nz-form-item>
                }

                <div nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left"></div>


                @if(isAttrAvailable('startDate') && !disableStatus){
                <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">

                    <nz-row>
                        <nz-form-label [nzSm]="5" [nzXs]="24" nzFor="startDate"
                            class="ppl-form-label">{{getAttributes('startDate').label}}
                            @if(getAttributes('startDate').mandatory === 'Y'){
                            <span [attr.aria-label]="'Required'">*</span>
                            }</nz-form-label>
                        <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                            <div nz-tooltip [nzTooltipTitle]="getAttributes('startDate')?.tooltip || ''"
                                nzTooltipPlacement="topRight">
                                <!-- <nz-date-picker formControlName="startDate" [id]="'startDate'" style="height: 32px;"
                                    [nzDisabledDate]="disabledStartDate" [nzFormat]="'MM/dd/yyyy'"
                                    [nzPlaceHolder]="getAttributes('startDate').placeholder"
                                    [ngClass]="{'error': validationErrors['startDate'] }"></nz-date-picker> -->
                                <ppl-date-picker formControlName="startDate" [id]="'startDate'"  [showIcon]="true"
                                [placeholder]="getAttributes('startDate').placeholder" dateFormat="mm/dd/yy" [yearRange]="'1900:2050'" [iconDisplay]="'input'"
                                [ariaLabel]="getAttributes('startDate').label" inputId="icondisplay" [panelStyleClass]="'custom-calendar-panel'" [maxDate]="minStartDate" 
                                [styleClass]="validationErrors['startDate'] ? 'error' : ''">
                                </ppl-date-picker>
                            </div>
                            @if (validationErrors['startDate']) {
                            <span class="pl-1 error-message">{{validationErrors['startDate']}}</span>
                            }
                        </nz-form-control>
                    </nz-row>
                </nz-form-item>
                }

                @if(isAttrAvailable('endDate') && !disableStatus){
                <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">

                    <nz-row>

                        <nz-form-label [nzSm]="5" [nzXs]="24" nzFor="endDate"
                            class="ppl-form-label">{{getAttributes('endDate').label}}
                            @if(getAttributes('endDate').mandatory === 'Y'){
                            <span [attr.aria-label]="'Required'">*</span>
                            }</nz-form-label>
                        <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                            <div nz-tooltip [nzTooltipTitle]="getAttributes('endDate')?.tooltip || ''"
                                nzTooltipPlacement="topRight">
                                <!-- <nz-date-picker formControlName="endDate" [id]="'endDate'" style="height: 32px;"
                                    [nzFormat]="'MM/dd/yyyy'" [nzDisabledDate]="disabledEndDate"
                                    [nzPlaceHolder]="getAttributes('endDate').placeholder"
                                    [ngClass]="{'error': validationErrors['endDate'] }"></nz-date-picker> -->
                                <ppl-date-picker formControlName="endDate" [id]="'endDate'"  [showIcon]="true"
                                [placeholder]="getAttributes('endDate').placeholder" dateFormat="mm/dd/yy" [yearRange]="'1900:2050'" [iconDisplay]="'input'"
                                [ariaLabel]="getAttributes('endDate').label" inputId="icondisplay" [panelStyleClass]="'custom-calendar-panel'" [minDate]="maxEndDate" 
                                [styleClass]="validationErrors['endDate'] ? 'error' : ''">
                                </ppl-date-picker>
                            </div>
                            @if (validationErrors['endDate']) {
                            <span class="pl-1 error-message">{{validationErrors['endDate']}}</span>
                            }
                        </nz-form-control>
                    </nz-row>
                </nz-form-item>
                }

                @if(isAttrAvailable('reason')){
                <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
                    <nz-row>
                        <nz-form-label [nzSm]="5" [nzXs]="24" nzFor="reason" class="ppl-form-label"
                            [authorizeField]="[pageId, tabId, 'Demographics', 'reason']">{{
                            getAttributes("reason").label }}
                            @if(getAttributes('reason').mandatory === 'Y'){
                            <span [attr.aria-label]="'Required'">*</span>
                            }</nz-form-label>
                        <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control" nz-tooltip
                            nzTooltipTitle="{{getAttributes('reason').tooltip}}" nzTooltipPlacement="topRight">
                            <div class="ppl-select" [ngClass]="{'error': validationErrors['reason'] }">
                                <ppl-dropdown-select formControlName="reason" id="reason"
                                placeholder="Select Reason" [options]="statusReasons" [optionLabel]="'lkpValueName'"
                                [optionValue]="'lkpValueCode'">
                                </ppl-dropdown-select>
                            </div>
                            @if (validationErrors['reason']) {
                            <span class="pl-1 error-message">{{validationErrors['reason']}}</span>
                            }
                        </nz-form-control>
                    </nz-row>
                </nz-form-item>
                }

                @if(isAttrAvailable('comment')){
                <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item  nz-padding-left">
                    <nz-row>
                        <nz-form-label [nzSm]="5" [nzXs]="24" nzFor="comment"
                            class="ppl-form-label">{{getAttributes('comment').label}}
                            @if(getAttributes('comment').mandatory === 'Y'){
                            <span [attr.aria-label]="'Required'">*</span>
                            }
                        </nz-form-label>
                        <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control" nz-tooltip
                            nzTooltipTitle="{{getAttributes('comment').tooltip}}" nzTooltipPlacement="topRight">
                            <textarea rows="4" cols="40" nz-input formControlName="comment" id="comment"
                                placeholder="{{getAttributes('comment').placeholder}}"
                                [ngClass]="{'error': validationErrors['comment'] }"></textarea>
                            @if (validationErrors['comment']) {
                            <span class="pl-1 error-message">{{validationErrors['comment']}}</span>
                            }
                        </nz-form-control>

                    </nz-row>

                </nz-form-item>
                }
            </form>
        </div>
    </div>
        }

        @if(prvdrAssociationsStatus && prvdrAssociationsStatus.length > 0) {
        @if(isMobileView) {
        <div class="card-layout">
            <div class="card" *ngFor="let association of prvdrAssociationsStatus">
                <div class="card-item mt-2">
                    <strong>{{ association.status }}</strong>
                </div>
                <div class="card-item">
                    Start Date : {{association.startDate}}
                </div>
                @if(association.endDate) {
                <div class="card-item">
                    End Date : {{association.endDate}}
                </div>
                }
                <div class="card-item">
                    {{ association.reason }}
                </div>
                <div class="card-item">
                    {{ association.comment }}
                </div>
                @if(showModifiedBy){
                    <div class="card-item">
                        Modified By: {{ association.modifiedBy }}
                    </div>
                }
                <div class="card-item mb-2">
                    Modified Date: {{ association.modifiedDate }}
                </div>
            </div>
        </div>
        } @else {
        <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="isAssociationsEditable"
            [data]="prvdrAssociationsStatus" [disableSelection]="true" [cols]="statusCols" [gridTitle]="false"
            [pagination]="false" [loadPage]="true" [actionButtons]="actionButtons"
            (gridAction)="action($event)"></ppl-list-table>
        }
        }
        @else {
        <nz-alert nzType="info" nzMessage="No data available for you." nzShowIcon></nz-alert>
        }
    </ng-template>
</div>
}
<div class="filter-panel">
    <ng-template #historyDialog let-cancel="cancel">
      @if(historyData?.length > 0){
        <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="false" [data]="historyData"
        [disableSelection]="true" [cols]="historyCols" [gridTitle]="false" [pagination]="true" [loadPage]="false">
    </ppl-list-table>
      }
      @else {
        No Data Available
      }
    </ng-template>
</div>
<div class="filter-panel">
    <ng-template #aorWaiverDialog let-cancel="cancel">
      <ppl-aor-waiver [associationId]="selectedAorAssociationId" [programCode]="program.program_code" [readonly]="!isAorEditable"></ppl-aor-waiver>
    </ng-template>
</div>
<ng-template #blockConfirmDialog>
    <p>Blocking the SSN will disassociate the PA from this consumer. Are you sure?</p>
</ng-template>
